

export const v1 = {
};